// app/components/ui/themeBits.js
import { alpha } from "@mui/material/styles";
import { red, orange } from "@mui/material/colors";

export const ORANGE_ACCENT = orange?.A400 || orange[600] || "#ff9100";

export const headerLikeBg = {
  position: "relative",
  overflow: "hidden",
  backgroundImage: `linear-gradient(135deg, ${alpha(red[600], 0.08)} 0%, ${alpha(
    ORANGE_ACCENT,
    0.08
  )} 100%)`,
  border: (t) => `1px solid ${t.palette.divider}`,
  "&:before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage:
      "radial-gradient(rgba(255,255,255,.16) 1px, transparent 1.5px)",
    backgroundSize: "14px 14px",
    pointerEvents: "none",
  },
};

export const heroSx = {
  pt: { xs: 7, sm: 9 },
  pb: { xs: 5, sm: 7 },
  backgroundImage: (t) =>
    `linear-gradient(135deg, ${alpha(red[600], 0.10)} 0%, ${alpha(
      ORANGE_ACCENT,
      0.10
    )} 100%)`,
  borderBottom: `1px solid ${alpha(red[600], 0.18)}`,
  position: "relative",
  overflow: "hidden",
  "&:after": {
    content: '""',
    position: "absolute",
    inset: 0,
    background: `radial-gradient(420px 260px at 0% 0%, ${alpha(
      "#fff",
      0.18
    )} 0%, transparent 60%),
      radial-gradient(460px 280px at 100% 100%, ${alpha("#fff", 0.10)} 0%, transparent 65%)`,
    pointerEvents: "none",
  },
};

export const titleGradient = {
  fontWeight: 900,
  fontSize: "clamp(32px, 5vw, 56px)",
  lineHeight: 1.12,
  letterSpacing: 0.2,
  background: `linear-gradient(90deg, ${red[700]} 0%, ${ORANGE_ACCENT} 100%)`,
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  color: "transparent",
};
